<app-dynamic-component-loader [component]="dashboardComponent" [injectableData]="injectableData"></app-dynamic-component-loader>
